export default function modulesIsActive(key, modulesStatus, country, isExternal = false) {
  if (modulesStatus === null) {
    return false
  }
  switch (key) {
    case 'assistanceProducts':
      return modulesStatus['assistance-options'] ?? false
    case 'monConseillerPersoProducts':
      return modulesStatus['mon-conseiller-perso-options'] ?? false
    case 'carbonOffset':
      return modulesStatus['carbon-offset'] ?? false
    case 'form':
      // countries that are only in V2 - don't have the link to V1 in menu
      // except FR external users for now that are still in V1
      if (isExternal) return true
      return ['fr', 'nl', 'de'].includes(country) ? false : true
    default:
      return true
  }
}
